import React from "react";
import { Navigate } from "react-router-dom";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Pages Calendar
import Calendar from "../pages/Calendar/index";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Register1 from "../pages/AuthenticationInner/Register";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

//Produtos
import Fornecedores from "../pages/Fornecedores/Fornecedores";
// import Avaliacoes from "../pages/Avaliacoes/Avaliacoes";
// import AvaliacaoAluno from "../pages/Avaliacoes/AvaliacaoAluno";
import Clientes from "pages/Clientes";
import Consultas from "pages/Consultas";
import PerfilCliente from "pages/Clientes/PerfilCliente";
import Servicos from "pages/Servicos";
import Medicos from "pages/Medicos";
import PerfilMedico from "pages/Medicos/PerfilMedico";
import Usuarios from "pages/Usuarios";
// import StatusPagamento from "../pages/StatusPagamento/StatusPagamento"

const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  // //calendar
  { path: "/calendar", component: <Calendar /> },

  // // //profile
  { path: "/profile", component: <UserProfile /> },

  //Avaliacoes
  // { path: "/Avaliacoes", component: <Avaliacoes /> },
  // { path: "/AvaliacaoAluno/:id", component: <AvaliacaoAluno /> },

  { path: "/medicos", component: <Medicos /> },
  { path: "/perfil-medico/:id", component: <PerfilMedico /> },

  //Compras
  { path: "/consultas", component: <Consultas /> },
  { path: "/perfil-cliente/:id", component: <PerfilCliente /> },
  { path: "/clientes", component: <Clientes /> },
  { path: "/servicos", component: <Servicos /> },
  { path: "/usuarios", component: <Usuarios /> },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
];

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
];

export { userRoutes, authRoutes };
